const DEFAULT_LOCALE = 'nl-NL'
export default DEFAULT_LOCALE
